/** KPIs do ROI das campanhas */
export interface CampanhaROIKPI {
    id: number;
    name: string;
    icon: string;
    cssClass?: string;
}

export const CAMAPANHA_ROI_KPI_RECURSOS: CampanhaROIKPI = {
    id: 1,
    name: 'Recursos',
    icon: 'fas fa-money-bill-wave'
};

export const CAMAPANHA_ROI_KPI_RESULTADO: CampanhaROIKPI = {
    id: 2,
    name: 'Resultado',
    icon: 'fas fa-dollar-sign'
};

export const CAMAPANHA_ROI_KPI_ROI_ZERADO: CampanhaROIKPI = {
    id: 3,
    name: 'ROI',
    icon: 'fas fa-equals',
    cssClass: 'campanha-roi-zerado'
};

export const CAMAPANHA_ROI_KPI_ROI_POSITIVO: CampanhaROIKPI = {
    id: 4,
    name: 'ROI',
    icon: 'far fa-thumbs-up',
    cssClass: 'campanha-roi-positivo'
};

export const CAMAPANHA_ROI_KPI_ROI_NEGATIVO: CampanhaROIKPI = {
    id: 5,
    name: 'ROI',
    icon: 'far fa-thumbs-down',
    cssClass: 'campanha-roi-negativo'
};

/** Retornar o KPI do ROI */
export function getROIKPI(roi: number): CampanhaROIKPI {
    roi = roi && !isNaN(roi) ? Number(roi) : 0;

    // Zerado
    if (roi === 0) {
        return CAMAPANHA_ROI_KPI_ROI_ZERADO;
    }
    // Positivo
    if (roi > 0) {
        return CAMAPANHA_ROI_KPI_ROI_POSITIVO;
    }
    // Negativo
    return CAMAPANHA_ROI_KPI_ROI_NEGATIVO;
}
